import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  MenuItem,
  Box
} from "@mui/material";
import { toast } from "react-toastify";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { getVideosWithLatLongs, saveVideoCoordinates } from "../apis/videos.apis";
import AddLatLongDialog from "../components/AddLatLongDialog";
import TablePagination from "@mui/material/TablePagination";


const AddVideoLatLong = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
  const [openCoordsDialog, setOpenCoordsDialog] = useState(false);
const [selectedCoordinates, setSelectedCoordinates] = useState([]);
const [selectedVideoName, setSelectedVideoName] = useState("");
const [openAddDialog, setOpenAddDialog] = useState(false);
const [selectedVideo, setSelectedVideo] = useState(null);
const [latLongCountFilter, setLatLongCountFilter] = useState("");
const [filterOperator, setFilterOperator] = useState("<");
const [page, setPage] = useState(0);
const rowsPerPage = 50;
   
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const data = await getVideosWithLatLongs();
        setVideos(data.videos);
      } catch (error) {
        console.error("Error fetching videos", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const handleShowLatLong = (coordinates, filename) => {
  setSelectedCoordinates(coordinates || []);
  setSelectedVideoName(filename);
  setOpenCoordsDialog(true);
};

const handleCloseCoordsDialog = () => {
  setOpenCoordsDialog(false);
  setSelectedCoordinates([]);
};


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedVideoUrl("");
  };

  const handleAddLatLong = (video) => {
    setSelectedVideo(video);
    setOpenAddDialog(true);
  };
  
  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    setSelectedVideo(null);
  };

  const filteredVideos = videos.filter((video) => {
  if (latLongCountFilter === "") return true;
  const count = video.lat_long_count || 0;
  const filterValue = parseInt(latLongCountFilter);

  if (filterOperator === "<") return count < filterValue;
  if (filterOperator === ">") return count > filterValue;
  if (filterOperator === "=") return count === filterValue;
  
  return true;
});

const paginatedVideos = filteredVideos.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

const handleSaveCoordinates = async ({ added, edited, deleted }) => {
  try {
    await saveVideoCoordinates(selectedVideo.video_id, { added, edited, deleted });

    const updated = await getVideosWithLatLongs();
    setVideos(updated.videos);

    toast.success("Coordinates Saved Successfully");
  } catch (error) {
    console.error("Error saving coordinates:", error);
    toast.error("Failed to save coordinates.");
  }
};

  

  return (
    <>
      <AppBar position="relative">
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Add Video Lat Long
          </Typography>
        </Toolbar>
      </AppBar>


      <Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
  flexWrap="wrap"
  sx={{ mb: 3, p: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}
>
  <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
    <Typography variant="subtitle1">Filter by Lat/Long Count:</Typography>
    <TextField
      label="Count"
      type="number"
      value={latLongCountFilter}
      onChange={(e) => setLatLongCountFilter(e.target.value)}
      size="small"
      sx={{ minWidth: 100 }}
    />
    {latLongCountFilter !== "" && (
      <TextField
        select
        label="Operator"
        value={filterOperator}
        onChange={(e) => setFilterOperator(e.target.value)}
        size="small"
        sx={{ minWidth: 80 }}
      >
        <MenuItem value="<">{"<"}</MenuItem>
        <MenuItem value=">">{">"}</MenuItem>
        <MenuItem value="=">{"="}</MenuItem>
      </TextField>
    )}
  </Box>

  <Button
    onClick={() => {
      setLatLongCountFilter("");
      setFilterOperator("<");
    }}
    size="small"
    variant="outlined"
    color="primary"
  >
    Clear Filter
  </Button>
</Box>
      <Container sx={{ mt: 4 }}>
        {loading ? (
          <CircularProgress />
        ) : videos.length === 0 ? (
          <Typography>No videos with less than 7 lat/long points found.</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Filename</TableCell>
                  <TableCell>Video ID</TableCell>
                  <TableCell>Zone</TableCell>
                  <TableCell>State</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Lat/Long Count</TableCell>
                  <TableCell>Add Lat Long</TableCell>
                  <TableCell>Show Lat Long</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedVideos.map((video) => (
                  <TableRow key={video.video_id}>
                    <TableCell>{video.filename}</TableCell>
                    <TableCell>{video.video_id}</TableCell>
                    <TableCell>{video.zone_name || "N/A"}</TableCell>
                    <TableCell>{video.state_name || "N/A"}</TableCell>
                    <TableCell>{video.city_name || "N/A"}</TableCell>
                    <TableCell>{video.lat_long_count}</TableCell>
                    <TableCell>
                      <Button variant="contained" size="small" onClick={() => handleAddLatLong(video)}>Add</Button>
                    </TableCell>
                    <TableCell>
                      <Button variant="outlined" size="small" onClick={() => handleShowLatLong(video.coordinates, video.filename)}>Show</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
       <TablePagination
  component="div"
  count={filteredVideos.length}
  page={page}
  onPageChange={(event, newPage) => setPage(newPage)}
  rowsPerPage={rowsPerPage}
  rowsPerPageOptions={[10]} // Optional: Fixed 10 rows/page
  onRowsPerPageChange={() => {}} // Required, but can be ignored if rowsPerPage is fixed
/>


        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
          <DialogContent>
            <video src={selectedVideoUrl} controls style={{ width: "100%" }} />
          </DialogContent>
        </Dialog>
        <Dialog open={openCoordsDialog} onClose={handleCloseCoordsDialog} maxWidth="sm" fullWidth>
  <DialogContent>
    <Typography variant="h6" gutterBottom>
      Coordinates for {selectedVideoName}
    </Typography>
    {selectedCoordinates.length === 0 ? (
      <Typography>No coordinates available.</Typography>
    ) : (
      <ul>
        {selectedCoordinates.map((coord, index) => (
          <li key={index}>
            Lat: {coord.lat}, Lng: {coord.lng}
          </li>
        ))}
      </ul>
    )}
  </DialogContent>
</Dialog>
{selectedVideo && (
  <AddLatLongDialog
    open={openAddDialog}
    onClose={handleCloseAddDialog}
    video={selectedVideo}
    onSave={handleSaveCoordinates}
  />
)}
      </Container>
    </>
  );
};

export default AddVideoLatLong;
